const pluginOptionsSchema = ({ Joi }) => (
  Joi.object({
    handle: Joi.string().required().description('The handle (ID) for your ADA chatbot.'),
    delay: Joi.number().description('Optional. The delay (in milliseconds) before the ADA chatbot displays.').default(0),
    zIndex: Joi.number().description('Optional. The Z-Index of the ada frame.').default(1000),
    dismissButton: Joi.boolean().description('Optional. Whether or not a dismiss button should display.').default(true),
    dismissDuration: Joi.alternatives().try(Joi.string(), Joi.number()).description('Optional. The delay (in milliseconds) until the chatbot should show again after dismissal.').default('session'),
    adaSettings: Joi.object().description('Optional. The settings object ingested by the ADA chatbot upon load.').default({}),
    defer: Joi.boolean().description('Optional. Enable/disable defer property on script.'),
    async: Joi.boolean().description('Optional. Enable/disable async property on script.'),
  })
);

const defaultPluginOptions = {
  delay: 0,
  zIndex: 1000,
  dismissButton: true,
  dismissDuration: 'session',
  adaSettings: {},
};

module.exports = {
  pluginOptionsSchema,
  defaultPluginOptions,
};
